import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

const generateEmsName = (partNumber: string) => `DPV2PDPExactPromotion_${partNumber}`;

const EmptyElement = () => null;

export const PDPExactPromotionContentRecommendation = ({ partNumber }: { partNumber: string }) => {
	const emsName = generateEmsName(partNumber);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{ emsName }}
			withoutFrame
			loadingElement={<Skeleton sx={{ height: '27px', width: '100%' }} />}
			emptyElement={<EmptyElement />}
		/>
	);
};
